import { get } from "react-hook-form";
import { getFormInstance } from "../repositories/FormsRepository";
import { useFormsContext } from "../context/formsContext";
import { getGroupedInstance } from "../helpers/getGroupedInstance";

export const useGetNewInstance = () => {
	const {
		state: { newInstanceId },
		actions: {
			setFormInstanceRows,
			setFormInstanceSections,
			setFormInstanceQuestions,
			setLayoutCode,
		},
	} = useFormsContext();

	return async () => {
		return getFormInstance(newInstanceId as any).then((res) => {
			if (res.ok) {
				const instanceRows = get(res, "data", null);
				const instanceTable = instanceRows.tables[0];
				const { formInstance, groupedSections, groupedQuestions } =
					getGroupedInstance(instanceTable.rows);
				setFormInstanceRows(formInstance);
				setFormInstanceSections(groupedSections);
				setFormInstanceQuestions(groupedQuestions);
				setLayoutCode(formInstance[0]?.LayoutCode);
			}
			return res;
		});
	};
};
